import { ESuburbanWCType } from '../../../../JsonQuery';

export const SUBURBAN_WC_MAP_VALUE_TO_LABEL = {
  [ESuburbanWCType.Inside]: 'в доме',
  [ESuburbanWCType.Outside]: 'на улице',
};
